export default __webpack_public_path__ + "static/media/clack.e9f96946.png";